import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PaystackButton } from 'react-paystack';
import { useMutation } from 'react-query';
import { Redirect } from 'react-router-dom';

import img from '../../../assets/images/newLogo.png';
import tick from '../../../assets/images/Group.svg';
// import Button from '../../../components/Button';
import Layout from '../../../components/Layout';

import './css/index.css';

export default function Success(props) {
  const location = useLocation();
  let {
    from,
    email,
    phoneNumber,
    data,
    fullName,
    price,
    packageName,
  } = location.state || {
    from: null,
    email: null,
    phoneNumber: null,
    data: null,
    fullName: null,
    price: null,
    packageName: null,
  };

  const [redirect, setRedirect] = useState(false);
  const [config, setConfig] = useState({
    email,
    amount: price * 100,
    meta: {
      name: fullName,
      phone: phoneNumber,
    },
    publicKey: 'pk_test_98e725b3f2d6742022fda3394c8890ba3073200a',
    text: 'Proceed to payment',
    onSuccess: () => finalize(),
    onClose: () => alert("Wait! Don't leave :("),
  });

  const [finalize, { isSuccess, isLoading }] = useMutation(() => {
    return fetch(
      `https://testapi.hendrayfinvest.com/user/sign-up/${from}/finalize/${data.data.ref}`,
      { method: 'POST', headers: { 'content-type': 'application/json' } }
    );
  });

  useEffect(() => {
    if (!email || !from || !data) {
      setRedirect(true);
    }
  }, [email, from, data]);

  return (
    <Layout {...props}>
      {' '}
      {redirect && <Redirect to={{ pathname: '/' }} />}
      <div className="folder fullFolder">
        <div className="file">
          <div className="imageField">
            <img src={img} alt="logo" />
          </div>

          <div className="straightLine">
            <div className="lineBorder"></div>
          </div>

          <div className="this">
            <h1>
              <span>PACKAGE: </span> {packageName}
            </h1>
            <h2>Registration & Payment</h2>
            <hr />
            <div className="regField">
              <p>Registration Complete</p>
              <img src={tick} alt="tick" />
            </div>
            <div className="formFle topAcc">
              {isLoading && <p>Finalizing...</p>}
              {isSuccess ? (
                <p> Check your email to complete the next stage</p>
              ) : (
                <PaystackButton {...config} className="acc-submit" />
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
